const API_BASE = import.meta.env.VITE_API_URL || "http://localhost:5001";

/**
 * Clean all user data but keep the account (SuperAdmin only)
 * @param {string} email - Email of the user to clean
 * @param {string} token - Auth token
 * @returns {Promise<Object>} Result with details of what was deleted
 */
export const cleanUserData = async (email, token) => {
  try {
    const response = await fetch(`${API_BASE}/api/users/clean`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ email }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Failed to clean user data");
    }

    return data;
  } catch (error) {
    console.error("Error cleaning user data:", error);
    throw error;
  }
};

/**
 * Wipe a user completely from the system (SuperAdmin only)
 * @param {string} email - Email of the user to wipe
 * @param {string} token - Auth token
 * @returns {Promise<Object>} Result with details of what was deleted
 */
export const wipeUser = async (email, token) => {
  try {
    const response = await fetch(`${API_BASE}/api/users/wipe`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ email }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Failed to wipe user");
    }

    return data;
  } catch (error) {
    console.error("Error wiping user:", error);
    throw error;
  }
};
